div<template>
  <div class="bloco-divisao">
    <div class="modal-produto-item">
      <h3>MARCA</h3>
      <CenarioInput
        tipo="texto"
        maxlength="300"
        placeholder="Insira a Marca do Produto"
        :model="marca"
        @update:model="update => this.calculaProdutosForm(update, 'marca')"
      />
    </div>
    <div class="modal-produto-item">
      <h3>FABRICANTE</h3>
      <CenarioInput
        tipo="texto"
        maxlength="300"
        placeholder="Insira o Fabricante do Produto"
        :model="fabricante"
        @update:model="update => this.calculaProdutosForm(update, 'fabricante')"
      />
    </div>
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";

export default {
  name: "ModalProdutoDetalhes",
  components: { CenarioInput },
  inject: ["calculaProdutosForm"],
  props: {
    exibeValidacao: Boolean,
    validaCampos: Object,
    produtosForm: Object
  },
  data() {
    return {
      codigo: "",
      marca: "",
      fabricante: ""
    };
  },
  created() {
    this.$nextTick(() => {
      this.updateDados();
    });
  },
  watch: {
    produtosForm: {
      deep: true,
      handler() {
        this.updateDados();
      }
    }
  },
  methods: {
    updateDados() {
      this.marca = this.produtosForm.marca;
      this.fabricante = this.produtosForm.fabricante;
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}
.bloco-divisao {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 10px 10px;
}
.modal-produto-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
